import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateTransferInput } from 'apis/ewallet';
import { MyInvoicesService } from '../services/my-invoices.service';
import { ValuesService } from '../services/values.service';

@Component({
  selector: 'app-invoices-create-new',
  templateUrl: './invoices-create-new.page.html',
  styleUrls: ['./invoices-create-new.page.scss'],
})
export class InvoicesCreateNewPage implements OnInit {

  form: FormGroup;
  negativeValueErrors: Array<string>;
  myValidation = false;

  constructor(private myInvoicesService: MyInvoicesService,
              public valuesService: ValuesService) {

    this.negativeValueErrors = new Array<string>();

    // FormGroup
    this.form = new FormGroup({
      account: new FormControl('', [Validators.required]),
      userIdResq: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required]),
      description: new FormControl('', []),
      externalReference: new FormControl('', []),
    });

    // externalReference es para que indique un id para relacionar el deposito o la transferencia es como algun comprobante

    this.form.controls['value'].valueChanges.subscribe(val => {
      if (val === null || val === undefined ) {

      } else {
        // Control Positive
        if (val < 1 ) {
          this.negativeValueErrors['value'] = 'O valor deve ser positivo';
          this.myValidation = false;
        } else {
          this.negativeValueErrors['value'] = '';
          this.myValidation = true;
        }
      }
    });
  }

  ngOnInit() {
  }

  createInvoice() {
    const account = this.form.controls['account'].value;
    const userIdResq = this.form.controls['userIdResq'].value;
    const createTransferInput =  new Object();
    (createTransferInput as CreateTransferInput).value = this.form.controls['value'].value;
    (createTransferInput as CreateTransferInput).description = this.form.controls['description'].value;
    (createTransferInput as CreateTransferInput).externalReference = this.form.controls['externalReference'].value;

    this.myInvoicesService.createInvoice(account, userIdResq, createTransferInput);
  }

}


